<template>
  <modal
    id="export_commandes_factures"
    class="modal-export"
    name="ModalExportCommandesFactures"
    :width="screenSizeIsSmall ? '450px' : '600px'"
    height="auto"
    @before-open="beforeOpen"
    @before-close="beforeClosed"
  >
    <div class="modal-center-content">
      <h2>Export de données</h2>
      <div class="contenu-modal">
        <div class="contenu-principal">
          <b-row class="block-input">
            <b-col cols="6">
              <strong>Type de format&nbsp;:</strong>
            </b-col>
            <b-col
              cols="3"
              class="zone-input"
            >
              <label>
                <input
                  v-model="typeFormat"
                  type="radio"
                  value="pdf"
                >
                PDF
              </label>
            </b-col>
            <b-col
              cols="3"
              class="zone-input"
            >
              <label>
                <input
                  v-model="typeFormat"
                  type="radio"
                  value="xls"
                >
                XLS
              </label>
            </b-col>
          </b-row>
          <b-row class="block-input">
            <b-col
              cols="12"
              class="label-title"
            >
              <strong>Élément(s) à faire figurer&nbsp;:</strong>
            </b-col>
            <b-col
              cols="3"
              class="zone-input"
            >
              <label class="normal">
                <input
                  v-model="isbn"
                  type="checkbox"
                  name="isbn"
                >
                ISBN
              </label>
            </b-col>
            <b-col
              cols="3"
              class="zone-input"
            >
              <label class="normal">
                <input
                  v-model="echeance"
                  type="checkbox"
                  name="echeance"
                >
                Échéance
              </label>
            </b-col>
            <b-col
              cols="3"
              class="zone-input"
            >
              <label class="normal">
                <input
                  v-model="prixPublic"
                  type="checkbox"
                  name="prix_public"
                >
                Prix public
              </label>
            </b-col>
            <b-col
              cols="3"
              class="zone-input"
            >
              <label class="normal">
                <input
                  v-model="prixNet"
                  type="checkbox"
                  name="prix_net"
                >
                Prix net
              </label>
            </b-col>
            <b-col
              v-if="hasCmd4d"
              cols="12"
              class="zone-input"
            >
              <label class="normal">
                <input
                  v-model="cmdMerged"
                  type="checkbox"
                  name="isbn"
                >
                Inclure les commandes fusionnées
              </label>
            </b-col>
          </b-row>
        </div>

        <div class="boutons-modal">
          <button
            v-focus
            class="btn"
            :class="hoverCancel ? '' : 'default'"
            @click.stop="exporter"
          >
            Exporter
          </button>
          <button
            class="btn-red"
            @click.stop="$modal.hide('ModalExportCommandesFactures')"
            @mouseover="hoverCancel = true"
            @mouseleave="hoverCancel = false"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import config from "@/config";

export default {
  name: "ModalExportCommandesFactures",
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      params: {},
      typeFormat: "pdf",

      hoverCancel: false,
      isbn: false,
      echeance: false,
      prixPublic: false,
      prixNet: false,
      cmdMerged: false,
    };
  },
  computed: {
    screenSizeIsSmall() {
      return window.innerWidth < 768;
    },
    hasCmd4d() {
      return this.params
        && this.params.lignes
        && this.params.lignes.some((ligne) => ligne.commande_4d && ligne.commande_4d.id_4d);
    },
  },
  methods: {
    /**
     * Configure la modale avec les données fournies lors de son ouverture.
     * @public
     * @param {Object} event Données pour la modale.
     */
    beforeOpen(event) {
      this.params = event.params;
    },
    /**
     * Configure la modale lors de sa fermeture.
     * @public
     */
    beforeClosed() {
      this.hoverCancel = false;
    },
    /**
     * Exporte l'entité sélectionnée selon les paramètres choisis.
     * @public
     */
    exporter() {
      let type = `${this.params.type}=${this.params.lignes.map((ligne) => ligne.id).join(",")}`;

      if (this.hasCmd4d && this.cmdMerged) {
        type = `commande_4d=${this.params.lignes.map((ligne) => ligne.commande_4d.id_4d).join(",")}`;
      }

      window.open(
        `${config.api.baseUrl}/export/commande/?${type}&type_format=${this.typeFormat}&isbn=${this
          .isbn}&echeance=${this.echeance}&prix_public=${this
          .prixPublic}&prix_net=${this.prixNet}`,
        "_blank",
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/style/_modalPrompt.scss";
</style>
